export default __webpack_public_path__ + "static/assets/syncing-bg.1541666f.png";